/**
 * 标准键盘事件码
 * @public
 */
var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["EMPTY"] = -1] = "EMPTY";
    KeyCode[KeyCode["BREAK"] = 3] = "BREAK";
    KeyCode[KeyCode["BACKSPACE"] = 8] = "BACKSPACE";
    KeyCode[KeyCode["TAB"] = 9] = "TAB";
    KeyCode[KeyCode["CLEAR"] = 12] = "CLEAR";
    KeyCode[KeyCode["ENTER"] = 13] = "ENTER";
    KeyCode[KeyCode["SHIFT"] = 16] = "SHIFT";
    KeyCode[KeyCode["CTRL"] = 17] = "CTRL";
    KeyCode[KeyCode["ALT"] = 18] = "ALT";
    KeyCode[KeyCode["PAUSE"] = 19] = "PAUSE";
    KeyCode[KeyCode["CAPS_LOCK"] = 20] = "CAPS_LOCK";
    KeyCode[KeyCode["ESCAPE"] = 27] = "ESCAPE";
    KeyCode[KeyCode["SPACE"] = 32] = "SPACE";
    KeyCode[KeyCode["PAGE_UP"] = 33] = "PAGE_UP";
    KeyCode[KeyCode["PAGE_DOWN"] = 34] = "PAGE_DOWN";
    KeyCode[KeyCode["END"] = 35] = "END";
    KeyCode[KeyCode["HOME"] = 36] = "HOME";
    KeyCode[KeyCode["ARROW_LEFT"] = 37] = "ARROW_LEFT";
    KeyCode[KeyCode["ARROW_UP"] = 38] = "ARROW_UP";
    KeyCode[KeyCode["ARROW_RIGHT"] = 39] = "ARROW_RIGHT";
    KeyCode[KeyCode["ARROW_DOWN"] = 40] = "ARROW_DOWN";
    KeyCode[KeyCode["SELECT"] = 41] = "SELECT";
    KeyCode[KeyCode["PRINT"] = 42] = "PRINT";
    KeyCode[KeyCode["EXECUTE"] = 43] = "EXECUTE";
    KeyCode[KeyCode["PRINT_SCREEN"] = 44] = "PRINT_SCREEN";
    KeyCode[KeyCode["INSERT"] = 45] = "INSERT";
    KeyCode[KeyCode["DELETE"] = 46] = "DELETE";
    KeyCode[KeyCode["HELP"] = 47] = "HELP";
    KeyCode[KeyCode["NUM_0"] = 48] = "NUM_0";
    KeyCode[KeyCode["NUM_1"] = 49] = "NUM_1";
    KeyCode[KeyCode["NUM_2"] = 50] = "NUM_2";
    KeyCode[KeyCode["NUM_3"] = 51] = "NUM_3";
    KeyCode[KeyCode["NUM_4"] = 52] = "NUM_4";
    KeyCode[KeyCode["NUM_5"] = 53] = "NUM_5";
    KeyCode[KeyCode["NUM_6"] = 54] = "NUM_6";
    KeyCode[KeyCode["NUM_7"] = 55] = "NUM_7";
    KeyCode[KeyCode["NUM_8"] = 56] = "NUM_8";
    KeyCode[KeyCode["NUM_9"] = 57] = "NUM_9";
    KeyCode[KeyCode["A"] = 65] = "A";
    KeyCode[KeyCode["B"] = 66] = "B";
    KeyCode[KeyCode["C"] = 67] = "C";
    KeyCode[KeyCode["D"] = 68] = "D";
    KeyCode[KeyCode["E"] = 69] = "E";
    KeyCode[KeyCode["F"] = 70] = "F";
    KeyCode[KeyCode["G"] = 71] = "G";
    KeyCode[KeyCode["H"] = 72] = "H";
    KeyCode[KeyCode["I"] = 73] = "I";
    KeyCode[KeyCode["J"] = 74] = "J";
    KeyCode[KeyCode["K"] = 75] = "K";
    KeyCode[KeyCode["L"] = 76] = "L";
    KeyCode[KeyCode["M"] = 77] = "M";
    KeyCode[KeyCode["N"] = 78] = "N";
    KeyCode[KeyCode["O"] = 79] = "O";
    KeyCode[KeyCode["P"] = 80] = "P";
    KeyCode[KeyCode["Q"] = 81] = "Q";
    KeyCode[KeyCode["R"] = 82] = "R";
    KeyCode[KeyCode["S"] = 83] = "S";
    KeyCode[KeyCode["T"] = 84] = "T";
    KeyCode[KeyCode["U"] = 85] = "U";
    KeyCode[KeyCode["V"] = 86] = "V";
    KeyCode[KeyCode["W"] = 87] = "W";
    KeyCode[KeyCode["X"] = 88] = "X";
    KeyCode[KeyCode["Y"] = 89] = "Y";
    KeyCode[KeyCode["Z"] = 90] = "Z";
    KeyCode[KeyCode["META_LEFT"] = 91] = "META_LEFT";
    KeyCode[KeyCode["META_RIGHT"] = 93] = "META_RIGHT";
    KeyCode[KeyCode["NUM_TIMES"] = 106] = "NUM_TIMES";
    KeyCode[KeyCode["NUM_PLUS"] = 107] = "NUM_PLUS";
    KeyCode[KeyCode["NUM_MINUS"] = 109] = "NUM_MINUS";
    KeyCode[KeyCode["NUM_POINT"] = 110] = "NUM_POINT";
    KeyCode[KeyCode["NUM_DIVIDE"] = 111] = "NUM_DIVIDE";
    KeyCode[KeyCode["F1"] = 112] = "F1";
    KeyCode[KeyCode["F2"] = 113] = "F2";
    KeyCode[KeyCode["F3"] = 114] = "F3";
    KeyCode[KeyCode["F4"] = 115] = "F4";
    KeyCode[KeyCode["F5"] = 116] = "F5";
    KeyCode[KeyCode["F6"] = 117] = "F6";
    KeyCode[KeyCode["F7"] = 118] = "F7";
    KeyCode[KeyCode["F8"] = 119] = "F8";
    KeyCode[KeyCode["F9"] = 120] = "F9";
    KeyCode[KeyCode["F10"] = 121] = "F10";
    KeyCode[KeyCode["F11"] = 122] = "F11";
    KeyCode[KeyCode["F12"] = 123] = "F12";
    KeyCode[KeyCode["SEMI"] = 186] = "SEMI";
    KeyCode[KeyCode["EQUAL"] = 187] = "EQUAL";
    KeyCode[KeyCode["COMMA"] = 188] = "COMMA";
    KeyCode[KeyCode["MINUS"] = 189] = "MINUS";
    KeyCode[KeyCode["PERIOD"] = 190] = "PERIOD";
    KeyCode[KeyCode["SLASH"] = 191] = "SLASH";
    KeyCode[KeyCode["BACKQUOTE"] = 192] = "BACKQUOTE";
    KeyCode[KeyCode["BRACKET_LEFT"] = 219] = "BRACKET_LEFT";
    KeyCode[KeyCode["BACK_SLASH"] = 220] = "BACK_SLASH";
    KeyCode[KeyCode["BRACKET_RIGHT"] = 221] = "BRACKET_RIGHT";
    KeyCode[KeyCode["QUOTATION_MARK"] = 222] = "QUOTATION_MARK";
})(KeyCode || (KeyCode = {}));
/**
 * Firefox 特有键盘事件码
 * @public
 */
var KeyCodeFireFox;
(function (KeyCodeFireFox) {
    KeyCodeFireFox[KeyCodeFireFox["EQUAL"] = 61] = "EQUAL";
    KeyCodeFireFox[KeyCodeFireFox["MINUS"] = 173] = "MINUS";
    KeyCodeFireFox[KeyCodeFireFox["META_FIREFOX"] = 224] = "META_FIREFOX";
})(KeyCodeFireFox || (KeyCodeFireFox = {}));
/**
 * 辅助键键盘事件码
 * @public
 */
var KeyAssist;
(function (KeyAssist) {
    KeyAssist[KeyAssist["SHIFT"] = 1000] = "SHIFT";
    KeyAssist[KeyAssist["ALT"] = 10000] = "ALT";
    KeyAssist[KeyAssist["CTRL_WIN"] = 100000] = "CTRL_WIN";
    KeyAssist[KeyAssist["CTRL_MAC"] = 200000] = "CTRL_MAC";
    KeyAssist[KeyAssist["WIN"] = 1000000] = "WIN";
    KeyAssist[KeyAssist["COMMAND"] = 2000000] = "COMMAND";
})(KeyAssist || (KeyAssist = {}));
/**
 * @internal
 */
const MOUSE_EVENT_TIMES = 1e7;
/**
 * 鼠标事件码
 * @public
 */
var MouseCode;
(function (MouseCode) {
    MouseCode[MouseCode["PRIMARY_BUTTON"] = 10000000] = "PRIMARY_BUTTON";
    MouseCode[MouseCode["SECONDARY_BUTTON"] = 20000000] = "SECONDARY_BUTTON";
    MouseCode[MouseCode["MIDDLE_BUTTON"] = 40000000] = "MIDDLE_BUTTON";
})(MouseCode || (MouseCode = {}));
/**
 * 滚轮事件码
 * @public
 */
var WheelCode;
(function (WheelCode) {
    WheelCode[WheelCode["WHEEL_ANTICLOCKWISE"] = 100000000] = "WHEEL_ANTICLOCKWISE";
    WheelCode[WheelCode["WHEEL_CLOCKWISE"] = 200000000] = "WHEEL_CLOCKWISE";
})(WheelCode || (WheelCode = {}));
/**
 * 键盘事件类型
 * @public
 */
var KeyType;
(function (KeyType) {
    KeyType["KEY_UP"] = "keyup";
    KeyType["KEY_PRESS"] = "keypress";
    KeyType["KEY_DOWN"] = "keydown";
})(KeyType || (KeyType = {}));

export { KeyAssist, KeyCode, KeyCodeFireFox, KeyType, MOUSE_EVENT_TIMES, MouseCode, WheelCode };
//# sourceMappingURL=key-code.js.map
